var chunkMapping = {
	"94642": [
		72802
	]
};
var idToExternalAndNameMapping = {
	"72802": [
		"default",
		"./appInjector",
		76719
	]
};
var idToRemoteMap = {
	"72802": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 76719
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}